
<template>
  <div class="SubjectTable">
    <el-dialog
      title="单价选择"
      width="400px"
      append-to-body
      :visible.sync="visible"
      @close="clearData"
      :show="show"
    >
      <div
        class="content_box"
        ref="key_content"
        id="key_content"
        tabindex="1"
        @keydown.up="upkey($event)"
        @keydown.down="downkey($event)"
        @keydown.enter="enterkey($event)"
      >
        <!-- <div class="content_top">
          <el-input
            ref="input"
            v-model="searchText"
            size="mini"
            placeholder="输入名称/编号"
            class="search_input"
            @keydown.up.native="upkey($event)"
            @keydown.down.native="downkey($event)"
            @keydown.enter.native="enterkey($event)"
          ></el-input>
          <el-checkbox v-model="showLeve" style="margin-left:10px;" @change="checkChange">显示层级结构</el-checkbox>
          <el-button type="warning" size="mini" class="search_btn" @click="searchClick">查询</el-button> 
        </div>-->
        <div class="content_infor_box">
          <vxe-table
            ref="xTable"
            class="right"
            size="small"
            border
            highlight-hover-row
            highlight-current-row
            :keyboard-config="{isArrow:true}"
            :auto-resize="true"
            height="auto"
            :data="tableData"
            show-overflow
            show-header-overflow
            @cell-dblclick="dbclick"
            @cell-click="cellclicks"
          >
            <template v-for="(item,index) in tableHeadData">
              <vxe-table-column
                :field="item.Key"
                :title="item.label"
                align="center"
                fixed="left"
                :key="index"
              ></vxe-table-column>
            </template>
          </vxe-table>
        </div>
        <!-- 分页 -->
        <!-- <el-pagination
          style="margin:10px auto 0;display: flex;justify-content: center; "
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20,50,100]"
          :page-size="pageSize"
          layout="total, sizes,prev, pager, next, jumper"
          :total="total"
        ></el-pagination>-->
      </div>
    </el-dialog>
  </div>
</template>  

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";
// 工具库
import tool from "@/utils/tool"; //本地缓存存取
const bankData = [
  { label: "价格类型", Key: "FullName" },
  { label: "价格", Key: "Price" }
];
export default {
  data() {
    return {
      multipleSelection: {}, // 多选
      // 字段值
      searchText: this.textname, //收索内容
      treeData: [], //树状图数据
      tableData: [], //table表格数据
      tableHeadData: [...bankData], //表格表头配置字段
      // 状态值
      visible: this.show, //是否显示选择弹出框
      showLeve: true, //是否显示层级
      rowIndex: 0, //默认表格索引

      // 分页
      currentPage: 1, //当前页码
      total: 0, //总页数
      pageSize: 10 //每页显示数量
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    textname: {
      type: String,
      default: ""
    }
  },
  watch: {
    show() {
      this.visible = this.show;
      if (this.visible) {
        this.InitTable();
        this.$nextTick(() => {
          this.$refs.key_content.focus();
          // this.$refs.input.focus();
        });
      }
    },
    // 默认选中表格第一行
    tableData: {
      handler: function(newVal, oldVal) {
        let that = this;
        if (that.visible && newVal && newVal.length > 0) {
          that.rowIndex = 0; //重置索引
          that.$nextTick(() => {
            that.$refs.xTable.setCurrentRow(that.tableData[0]);
          });
        }
      },
      deep: true //对象内部的属性监听，也叫深度监听
    }
  },
  methods: {
    dbclick(row) {
      this.$emit("chooseBack", row.row);
      this.$emit("update:show", false);
    },
    // 请求table表格数据
    // 请求table表格数据
    InitTable() {
      let params;
      if (this.$attrs.searchData.PtypeId != "") {
        params = {
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          PtypeId: this.$attrs.searchData.PtypeId, //商品id
          BtypeId: this.$attrs.customerVal1.KtypeId, //客户id
          Unit: this.$attrs.searchData.Unit //商品单位id
        };
        this.request
          .post("/index/Goods/get_goods_unit_price", {
            jparams: JSON.stringify(params)
          })
          .then(res => {
            this.tableData = Object.values(res.data);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    // 退出清除数据
    clearData() {
      // 退出前是数据初始化
      this.$emit("update:show", false);
    },
    cellclicks({ $rowIndex }) {
      this.rowIndex = $rowIndex;
    },
    // 按上键
    upkey(e) {
      if (this.rowIndex != 0) {
        this.rowIndex = this.rowIndex - 1;
      }
      this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
      this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
    },
    // 按下键
    downkey(e) {
      let that = this;
      if (this.tableData && this.rowIndex + 1 < this.tableData.length) {
        this.rowIndex = this.rowIndex + 1;
      }
      that.$nextTick(() => {
        that.$refs.xTable.setCurrentRow(that.tableData[that.rowIndex]);
        that.$refs.xTable.scrollToRow(that.$refs.xTable.getCurrentRow());
      });
    },
    // 按回车键
    enterkey(e) {
      this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
      this.$nextTick(() => {
        this.$emit("chooseBack", this.$refs.xTable.getCurrentRow());
        this.$emit("update:show", false);
      });
    }
  },
  // 创建生命周期钩子函数
  mounted() {
    // 初始化数据
    this.InitTable();
    
  }
};
</script>

<style lang="less">
.content_btn_box {
  display: -webkit-box !important;
  display: box !important;
  position: relative;
  -webkit-box-align: center;
  box-align: center;
}
#key_content:focus {
  outline: none;
  border: 0;
  border-color: red;
}
.el-dialog__header {
  background: rebeccapurple;
  padding: 10px 10px 0;
  .el-dialog__title {
    color: #fff;
    font-size: 14px;
  }
  .el-dialog__headerbtn {
    top: 10px;
    right: 10px;
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }
}
.el-dialog__body {
  padding: 10px 20px;
}
.content_box {
  .content_top {
    width: 100%;
    height: 40px;
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    -webkit-box-align: center;
    box-align: center;
    .search_input {
      display: block;
      width: 200px;
    }
  }
  .content_infor_box {
    width: 100%;
    height: 300px;
    display: -webkit-box !important;
    display: box !important;
    position: relative;

    .right {
      height: 100%;
      position: relative;
      -webkit-box-flex: 1;
      box-flex: 1;
    }
  }
}
.el-tree {
  background: inherit;
}
//滚动条的宽度
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
  //   background-color: #a1a3a9;
  //   border-radius: 3px;
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ccc;
}
:-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/UnitPrice/UnitPrice.vue